module.exports = __webpack_public_path__ + "media/bg/user_profile_bg-8bc37a7c.jpg";